import clsx from 'clsx';
import React from 'react';
import useTextArea from './useTextArea';

type TextAreaProps = {
  'aria-describedby'?: string;
  'aria-invalid'?: boolean;
  'aria-label'?: string;
  'aria-required'?: boolean;
  className?: string;
  disabled?: boolean;
  id?: string;
  name?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  referer?: React.Ref<HTMLTextAreaElement>;
  required?: boolean;
  rows?: number;
  value?: string;
};

const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  (
    {
      'aria-label': ariaLabel,
      className,
      disabled = false,
      name,
      onChange = () => null,
      placeholder,
      referer,
      rows = 1,
      value,
      ...props
    },
    ref
  ) => {
    const { refTextArea, handleChange } = useTextArea({ onChange, ref, referer, value });

    return (
      <div className={clsx('textarea', className)}>
        <textarea
          name={name}
          className={clsx('textarea__input', { 'textarea__input--disabled': disabled })}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          disabled={disabled}
          ref={refTextArea}
          rows={rows}
          aria-label={ariaLabel}
          {...props}
        />
      </div>
    );
  }
);

TextArea.displayName = 'TextArea';

export default TextArea;
